import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-faq',
  template: `<ngx-one-column-layout>
               <router-outlet></router-outlet>
            </ngx-one-column-layout>`,
  styleUrls: ['./faq.component.scss']
})
export class FaqLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

}
